// import { Icon } from "../icon";
import LogoImg from "@/assets/images/login/logo.png";
import { cn } from "@/utils";
import { NavLink } from "react-router";

interface Props {
	size?: number | string;
	className?: string;
}
function Logo({ size = 50, className }: Props) {
	return (
		<NavLink to="/" className={cn(className)}>
			{/* <Icon icon="local:ic-logo-badge" size={size} color="var(--colors-palette-primary-default)" /> */}
			<img width={size} src={LogoImg} alt="logo" />
		</NavLink>
	);
}

export default Logo;
